var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadingCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-842.5 -592.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M60.469,18.875a23.414,23.414,0,0,0-43.75-6.25A18.742,18.742,0,0,0,18.75,50H59.375a15.58,15.58,0,0,0,1.094-31.125Z",
    transform: "translate(842.5 592.25)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M21.875,15.625v12.5H9.375v-12.5H0L15.625,0,31.25,15.625Z",
    transform: "translate(864.5 603.25)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingCloud);
export default __webpack_public_path__ + "static/media/uploading-cloud.407563459551ed97e6ffdf2e96eeeeaa.svg";
export { ForwardRef as ReactComponent };